export default __webpack_public_path__ + "7cfb064fe82be0cfd26658cffd18fdfd.png";